import Axios from 'axios';
import {getHeaders} from '../../utills';
import AlertAction from '../Actions/AlertActions';
import GeneralAction from '../Actions/GeneralAction';
import PaymentCardsActions from '../Actions/PaymentCardsActions';
import Apis from '../Apis';

class PaymentCardsMiddleware {
  static getPaymentCards = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(Apis.showCards, {
            headers: getHeaders()
          });
          if (data?.success) {
            resolve(data);
            dispatch(PaymentCardsActions.getPaymentCards(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static deletePaymentCards = id => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('stripe_source_id', id);
          const {data} = await Axios.post(
            Apis.deleteCard,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static updatePaymentCards = id => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.post(
            Apis.updateDefaultCard + `${id}`,
            {},
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static storeCards = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('card_number', userData?.card_number);
          formdata.append('exp_date', userData?.exp_date);
          formdata.append('cvc', userData?.cvc);
          const {data} = await Axios.post(
            Apis.storeCard,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(PaymentCardsActions.updatePaymentCardList(data?.data))
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default PaymentCardsMiddleware;
